export default "__VITE_ASSET__psS8mxBC__"